<template>
  <div class="app-container">
    <el-card class="mb5">
      <div style="margin-bottom: 20px">
        <el-form
          ref="formSearch" :model="queryForm" label-position="top"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('GlobalSetObj.ReturnTime')">
                <!--网点入库时间-->
                <el-date-picker
                  v-model="queryDateTime"
                  :default-time="['00:00:00', '23:59:59']"
                  :end-placeholder="$t('operationCenter.endDate')"
                  :start-placeholder="$t('operationCenter.startDate')"
                  range-separator="~"
                  style="width: 100%"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('collectionCenter.region')">
                <el-select
                  v-model="queryForm.params.regionId"
                  :placeholder="$t('placeOrder.pleaseChoose')"
                  clearable
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in regionList"
                    :key="item.id"
                    :label="item.zhName + '（' + item.puName + '）'"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 网点所属州 -->
            <el-col :span="4">
              <el-form-item :label="$t('collectionCenter.stateSite1')">
                <el-select
                  v-model="queryForm.params.stateList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in StateList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 网点 -->
            <el-col :span="5">
              <el-form-item :label="$t('GlobalSetObj.Outlets')">
                <el-select
                  v-model="queryForm.params.siteIdList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in siteList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <!--转运中心-->
              <el-form-item :label="$t('collectionCenter.owningTransitCenter1')">
                <el-select
                  v-model="queryForm.params.transitCenterIdList"
                  :placeholder="$t('GlobalSetObj.all')"
                  clearable
                  collapse-tags
                  filterable
                  multiple
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in TransferList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <div>
                <el-button
                  icon="el-icon-search"
                  size="small"
                  type="primary"
                  @click="searchResources(1)"
                >{{ $t('operationCenter.Procurar') }}
                </el-button>
                <el-button
                  icon="el-icon-upload2"
                  size="small"
                  style="margin-bottom: 10px"
                  type="primary"
                  @click="allExportOrder"
                >{{ $t('newOrder.export') }}
                </el-button>
                <el-button icon="el-icon-refresh-left" size="small" @click="searchResources(2)">
                  {{ $t('operationCenter.reset') }}
                </el-button>
                <el-button size="small" @click="diffExportOrder">{{ $t('tablePrice.exportDiscrepancyDetails') }}
                </el-button>
                <el-radio-group
                  v-model="queryForm.params.isTest"
                  size="small"
                  style="margin-left: 10px"
                  @change="searchResources(1)"
                >
                  <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
                  <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
                </el-radio-group>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
        />
        <el-table-column
          v-for="(item, ind) in columnList"
          :key="ind"
          :align="item.align"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot="header">
            <div>{{ item.label }}</div>
          </template>
          <template slot-scope="scope">
            <div
              v-if="strARR.includes(item.prop)"
              :class="strARR.includes(item.prop) ? 'table-active' : ''"
              @click="seeDetial(scope.row, item.prop, scope.row[item.prop], item.typeNum)"
            >
              {{ scope.row[item.prop] || 0 }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getCurrentTableData"
          @size-change="getSizeTableData"
        />
      </div>
    </el-card>
    <!-- 包裹详情-->
    <el-drawer
      :title="$t('customerManagements.detailTitle')"
      :visible.sync="dialogVisible"
      center
      direction="ltr"
      size="1200px"
      @close="closeDrawer"
    >
      <packageDetail
        v-if="dialogVisible"
        ref="votesDetails"
        :dataobj="dataObj"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
  </div>
</template>

<script>
import {
  getLgAreaListData,
  getSiteTransfer,
  regionQueryList,
  returnDataMonitoringexport,
  returnDataMonitoringPage,
  selectInfoByStateTwo
} from '@/api/orderApi';
import dayjs from 'dayjs';
import { allDiscrepancyExport } from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';
import { Loading } from 'element-ui';

export default {
  name: 'ReturnDataMonitoring',
  components: {
    packageDetail: () => import('./component/packageDetail')
  },
  data() {
    return {
      allSiteListCache: null,
      sitesByRegionAndState: {},
      regionList: [],
      dialogVisible: false, // 详情弹窗
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          transitCenterIdList: [],
          regionId: '',
          stateList: [],
          siteIdList: [],
          startTime: '',
          endTime: '',
          isTest: 1 // 数据类型（1正式 2测试）
        }
      },
      tableData: [],
      total: 0,
      StateList: [], // 州
      columnList: [
        // 大区 Região
        { label: this.$t('collectionCenter.region'), prop: 'regionName', width: 100 },
        // 网点所属州
        { label: this.$t('collectionCenter.stateSite1'), prop: 'state', width: 150 },
        // 所属转运中心
        {
          label: this.$t('collectionCenter.owningTransitCenter1'),
          prop: 'transitCenter',
          width: 150
        },
        // 网点
        { label: this.$t('collectionCenter.dot'), prop: 'site', width: 150 },
        // 退件时间
        { label: this.$t('GlobalSetObj.ReturnTime'), prop: 'operationTime', width: 180 },
        // 退件码
        { label: this.$t('scripting.returnCode'), prop: 'returnCode', width: 160 },
        // 车牌号
        { label: this.$t('seller.licensePlateNumber'), prop: 'vehicleNumber', width: 160 },
        // 司机名称
        { label: this.$t('collectionCenter.theDriverName'), prop: 'driverName', width: 160 },
        // 退件票数
        {
          label: this.$t('customerManagements.returnCount'),
          prop: 'returnCount',
          width: 170,
          typeNum: 1
        },
        // 二次入库票数
        {
          label: this.$t('customerManagements.secondaryStorageCount'),
          prop: 'secondaryStorageCount',
          width: 190,
          typeNum: 2
        },
        // 退仓到件票数
        {
          label: this.$t('customerManagements.returnedShipmentsCount'),
          prop: 'returnedShipmentsCount',
          width: 180,
          typeNum: 3
        },
        // 差异
        {
          label: this.$t('customerManagements.discrepancyCount'),
          prop: 'discrepancyCount',
          width: 160,
          typeNum: 4
        },
        // 疑似丢失
        {
          label: this.$t('operationTips.yisiLost'),
          prop: 'suspectedMissCount',
          width: 160,
          typeNum: 5
        }
      ],
      queryDateTime: [this.getAWeek().startDate, this.getAWeek().endDate],
      siteList: [],
      TransferList: [],
      dataObj: {},
      strARR: [
        'returnCount',
        'secondaryStorageCount',
        'returnedShipmentsCount',
        'discrepancyCount',
        'suspectedMissCount'
      ]
    };
  },
  watch: {
    'queryForm.params.regionId'(val) {
      this.queryForm.params.stateList = [];
      this.queryForm.params.siteIdList = [];
      if (val && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === val);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.StateList = selectedRegion.states.map((label) => ({ label }));
        }
        this.siteList = selectedRegion?.sites || [];
        this.groupSitesByRegionAndState();
      }
      if (!val) {
        this.StateList = [];
        this.getAddress();
        this.siteList = [];
        this.getSiteList();
      }
    },
    'queryForm.params.stateList'(val) {
      const regionId = this.queryForm.params.regionId;
      if (regionId) {
        this.queryForm.params.siteIdList = [];
      }
      if (!regionId && val) {
        if (this.allSiteListCache) {
          this.siteList = this.allSiteListCache;
        } else {
          this.getSiteList();
        }
        return;
      }

      // 如果没有选择州，则显示当前大区下的所有网点
      if (regionId && (!val || val.length <= 0)) {
        const selectedRegion = this.regionList.find((r) => r.id === regionId);
        this.siteList = selectedRegion?.sites || [];
      }
      if (regionId && val && val.length > 0) {
        const mergedSites = [];
        val.forEach((state) => {
          const sitesInState = this.sitesByRegionAndState[regionId]?.[state] || [];
          mergedSites.push(...sitesInState);
        });
        this.siteList = mergedSites;
      }
    }
  },
  created() {
    // 获取加盟商选项
    this.getAddress();
    this.getTableData(1);
    this.getSiteTransfer();
    this.getSiteList();
    this.getRegion();
  },
  methods: {
    // 大区
    getRegion() {
      regionQueryList(3).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    groupSitesByRegionAndState() {
      const grouped = {};
      this.regionList.forEach((region) => {
        if (!grouped[region.id]) {
          grouped[region.id] = {};
        }

        region.sites.forEach((site) => {
          const key = site.state; // 区分大小写
          if (!grouped[region.id][key]) {
            grouped[region.id][key] = [];
          }
          grouped[region.id][key].push(site);
        });
      });

      this.sitesByRegionAndState = grouped;
    },
    // 搜索、重置
    searchResources(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getTableData();
      } else {
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            transitCenterIdList: [],
            regionId: '',
            stateList: [],
            siteIdList: [],
            startTime: '',
            endTime: '',
            isTest: 1 // 数据类型（1正式 2测试）
          }
        };
        this.queryDateTime = [this.getAWeek().startDate, this.getAWeek().endDate];
        this.getTableData();
      }
    },
    // 获取最近30天时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD') + ' 23:59:59',
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD') + ' 00:00:00'
      };
    },
    // 获取加盟商时效统计列表
    getTableData(val) {
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        this.queryForm.params.startTime = this.queryDateTime[0];
        this.queryForm.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      returnDataMonitoringPage(this.queryForm)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records;
            this.tableData.forEach((item) => {
              item.date = item.date || '--';
            });
            if (val === 1) {
              loading.close();
            }
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    // 导出差异明细
    diffExportOrder() {
      const data = this.queryForm.params;
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.startTime = this.queryDateTime[0];
        data.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      allDiscrepancyExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    allExportOrder() {
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        this.queryForm.params.startTime = this.queryDateTime[0];
        this.queryForm.params.endTime = this.queryDateTime[1];
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      const data = this.queryForm.params;
      returnDataMonitoringexport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getTableData();
    },
    closeDrawer() {
      this.dialogVisible = false;
    },
    parentMethod(arg) {
      this.dialogVisible = arg;
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    seeDetial(row, porp, number, type) {
      console.log(row, porp, number);
      if (this.strARR.includes(porp)) {
        if (number) {
          this.dataObj = {
            id: row.id,
            siteId: row.siteId,
            operationTime: row.operationTime,
            operationUserId: row.operationUserId,
            isTest: this.queryForm.params.isTest,
            type: type
          };
          this.dialogVisible = true;
        }
      }
    },
    // 获取网点列表
    getSiteList() {
      if (this.allSiteListCache) {
        this.siteList = this.allSiteListCache;
        return Promise.resolve();
      }
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const data = {};
      selectInfoByStateTwo(data)
        .then((res) => {
          if (res.code === 200) {
            this.allSiteListCache = res.data.siteList; // 缓存全部网点
            this.siteList = [...this.allSiteListCache]; // 初始化为全量数据
          }
        })
        .finally(() => {
          load.close();
        });
    },
    getSiteTransfer() {
      getSiteTransfer().then((res) => {
        if (res.code === 200) {
          this.TransferList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.table-active {
  color: #00a551;
  cursor: pointer;
}
</style>
